import { useEffect } from "react";
import { useBetbyScriptLoaderViewModel } from "@/betby/viewmodels/useBetbyScriptLoaderViewModel";

// Global flag to prevent duplicate script loading across navigation
let isScriptLoaded = false;
let isScriptLoading = false;

export default function BetbyScriptLoader() {
  const { src } = useBetbyScriptLoaderViewModel();

  useEffect(() => {
    if (!src) return;

    // Skip if SDK already loaded or script is loading
    if (window.BTRenderer || isScriptLoaded || isScriptLoading) {
      return;
    }

    // Check if script tag already exists in DOM
    const existingScript = document.querySelector(
      `script[src="${src}"]`,
    ) as HTMLScriptElement | null;
    if (existingScript) {
      return;
    }

    isScriptLoading = true;
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => {
      isScriptLoaded = true;
      isScriptLoading = false;
      window.dispatchEvent(new Event("bt-renderer-loaded"));
    };
    script.onerror = () => {
      isScriptLoading = false;
      console.error("Failed to load Betby script:", src);
    };
    document.body.appendChild(script);

    // Intentionally do NOT remove script on cleanup:
    // 1. window.BTRenderer persists across navigation
    // 2. Removing script tag doesn't unload SDK, causes re-download
    // 3. Cleanup should only handle component state, not global SDK
  }, [src]);

  return null;
}
